/* Landeszusatz am Ende, den Nominatim und Importe gerne anhängen. */
const COUNTRY_SUFFIX =
  /,\s*(schweiz|switzerland|suisse|svizzera|ch|deutschland|germany|österreich|austria)\.?$/i;

/**
 * Zerlegt eine Adresse in Strasse und «PLZ Ort».
 *
 * Reihenfolge der Versuche:
 *   1. Strukturierte Felder einer Aktivität (location_street/_plz/_city).
 *   2. Adress-String mit Komma vor der Postleitzahl – nicht-gierig, damit
 *      beim ERSTEN Komma getrennt wird, auf das eine PLZ folgt.
 *   3. Adress-String ohne Komma ("Museumstrasse 2 8001 Zürich") – hier
 *      gierig, damit bei vierstelliger Hausnummer die HINTERE Zahl als
 *      Postleitzahl gilt ("Industriestr. 1234 8400 Winterthur").
 *
 * Greift nichts davon – etwa bei "Zoo Zürich", "Adresse eingeben" oder dem
 * Platzhalter "Koordinaten: 47.500000, 8.727000" –, gibt es keine sinnvolle
 * Zweiteilung: `cityLine` bleibt leer und die Aufrufer geben den Text
 * unverändert am Stück aus.
 */
export const splitAddress = (address, street, plz, city) => {
  const structuredCity = [plz, city].filter(Boolean).join(' ').trim();
  if (street && street.trim() && structuredCity) {
    return { streetLine: street.trim(), cityLine: structuredCity };
  }

  const text = (address || '').replace(COUNTRY_SUFFIX, '').trim();
  if (!text) return { streetLine: '', cityLine: '' };

  const withComma = text.match(/^(.*?),\s*(\d{4,5}\s+\S.*)$/);
  if (withComma) {
    return { streetLine: withComma[1].trim(), cityLine: withComma[2].trim() };
  }

  const withoutComma = text.match(/^(.*\S)\s+(\d{4,5}\s+\S.*)$/);
  if (withoutComma) {
    return { streetLine: withoutComma[1].trim(), cityLine: withoutComma[2].trim() };
  }

  return { streetLine: text, cityLine: '' };
};

export default splitAddress;
